import axios from 'axios';



export const getReport = async (userId) => {
      try {
          const res = await axios.post('/getAllReport',{userId:userId});
          return res.data;
      } catch (e) {
        return e.response.data;
      }
};
